var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoHeadermin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4585",
    viewBox: "0 0 242 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4559"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style4557"
  }, ".a{fill:#c73a63}.b{fill:#4b4b4b}.c{fill:#4a4a4a}"))), /*#__PURE__*/React.createElement("g", {
    "aria-label": "flow",
    style: {
      fontStyle: "italic",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 64,
      lineHeight: "125%",
      fontFamily: "'Brush Script MT'",
      InkscapeFontSpecification: "'Brush Script MT, Italic'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#374845",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    id: "text838",
    transform: "translate(-116.665 -76.504)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g45"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    },
    id: "g4181",
    transform: "scale(1.56282) rotate(45 53.995 96.16)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff",
      fillOpacity: 1
    },
    transform: "rotate(-135 15.774 43.157) scale(.36867)",
    id: "g4149"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-103.053 144.737)",
    cx: 13.566,
    cy: 86.286,
    rx: 13.566,
    ry: 13.714,
    id: "ellipse4137",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-103.053 144.737)",
    d: "M65.569 100H46.35c0-25.879-20.752-46.858-46.35-46.858V33.715c36.214 0 65.569 29.676 65.569 66.285z",
    id: "path4139",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-103.053 144.737)",
    d: "M79.135 100c0-44.183-35.429-80-79.135-80V0c54.631 0 98.918 44.772 98.918 100z",
    id: "path4141",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "text834",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 40,
      lineHeight: "125%",
      fontFamily: "Calibri",
      InkscapeFontSpecification: "'Calibri, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    "aria-label": "read"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path897",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 48,
      fontFamily: "Calibri",
      InkscapeFontSpecification: "'Calibri, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "M196.372 101.379q0 .844-.046 1.383-.047.539-.141.843-.094.305-.258.422-.14.118-.375.118-.187 0-.422-.07-.234-.094-.539-.188-.281-.094-.633-.164-.351-.094-.773-.094-.492 0-.984.21-.493.188-1.032.61-.515.422-1.101 1.125-.563.703-1.219 1.735v13.03q0 .235-.14.423-.141.164-.493.281-.328.117-.89.164-.563.07-1.43.07t-1.43-.07q-.562-.047-.914-.164-.328-.117-.469-.281-.14-.188-.14-.422V99.434q0-.235.117-.399.117-.187.422-.305.305-.117.773-.164.492-.07 1.219-.07.75 0 1.242.07.492.047.75.164.281.118.399.305.117.164.117.399v2.601q.82-1.172 1.547-1.922.726-.773 1.383-1.218.656-.446 1.312-.61.656-.187 1.313-.187.304 0 .656.047.351.023.726.117.375.07.657.187.28.094.398.211.14.117.188.258.07.14.117.398.047.235.07.727.023.492.023 1.336z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path899",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 48,
      fontFamily: "Calibri",
      InkscapeFontSpecification: "'Calibri, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "M218.755 109.277q0 1.078-.492 1.594-.469.516-1.312.516h-12.727q0 1.336.305 2.437.328 1.078 1.008 1.852.703.75 1.78 1.148 1.102.399 2.626.399 1.547 0 2.719-.211 1.171-.235 2.015-.492.867-.282 1.43-.493.562-.234.914-.234.21 0 .351.094.141.07.235.28.094.212.117.61.047.375.047.961 0 .516-.023.89-.024.352-.07.61-.048.258-.141.446-.094.164-.258.328-.14.164-.82.445-.68.281-1.735.562-1.055.258-2.414.446-1.36.21-2.906.21-2.79 0-4.899-.702-2.086-.704-3.492-2.133-1.406-1.43-2.11-3.61-.679-2.18-.679-5.109 0-2.789.727-5.016.726-2.25 2.11-3.796 1.382-1.57 3.35-2.391 1.993-.82 4.477-.82 2.625 0 4.477.773 1.875.773 3.07 2.156 1.195 1.36 1.758 3.235.562 1.875.562 4.078zm-5.718-1.687q.07-2.485-1.008-3.89-1.055-1.43-3.282-1.43-1.125 0-1.968.421-.82.422-1.383 1.149-.54.703-.844 1.687-.281.961-.328 2.063z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path901",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 48,
      fontFamily: "Calibri",
      InkscapeFontSpecification: "'Calibri, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "M241.443 120.41q0 .328-.235.516-.234.187-.75.258-.492.093-1.476.093-1.055 0-1.547-.093-.469-.07-.68-.258-.187-.188-.187-.516v-1.664q-1.29 1.383-2.953 2.156-1.641.774-3.657.774-1.664 0-3.07-.446-1.383-.421-2.414-1.265-1.008-.867-1.57-2.133-.563-1.266-.563-2.953 0-1.828.703-3.164.727-1.36 2.133-2.227 1.43-.89 3.54-1.312 2.109-.422 4.898-.422h2.039v-1.266q0-.984-.211-1.71-.188-.75-.656-1.243-.446-.492-1.22-.726-.75-.235-1.874-.235-1.477 0-2.649.328-1.148.328-2.039.727-.89.398-1.5.726-.586.329-.96.329-.258 0-.47-.164-.187-.165-.328-.47-.117-.304-.187-.75-.07-.445-.07-.984 0-.726.117-1.148.117-.422.445-.75.328-.352 1.149-.75.82-.422 1.921-.773 1.102-.352 2.391-.563 1.313-.234 2.695-.234 2.461 0 4.196.492 1.758.469 2.883 1.476 1.125.985 1.64 2.555.516 1.57.516 3.727zm-5.79-8.953h-2.25q-1.429 0-2.437.211-1.008.21-1.64.633-.633.422-.938 1.031-.281.586-.281 1.36 0 1.312.82 2.062.844.75 2.32.75 1.243 0 2.274-.633 1.055-.633 2.133-1.851z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path903",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 48,
      fontFamily: "Calibri",
      InkscapeFontSpecification: "'Calibri, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "M267.177 120.34q0 .258-.117.445-.117.164-.398.281-.282.118-.774.164-.469.047-1.172.047-.75 0-1.219-.047-.468-.046-.773-.164-.281-.117-.422-.28-.117-.188-.117-.446v-2.32q-1.617 1.734-3.398 2.695-1.758.96-3.915.96-2.39 0-4.054-.913-1.64-.938-2.696-2.508-1.03-1.57-1.5-3.656-.468-2.11-.468-4.43 0-2.79.586-5.016.609-2.226 1.757-3.797 1.149-1.57 2.86-2.414 1.71-.843 3.937-.843 1.758 0 3.188.726 1.43.703 2.836 2.086V89.59q0-.235.117-.422.14-.188.469-.305.351-.14.914-.21.562-.071 1.43-.071.867 0 1.43.07.562.07.89.211.328.117.469.305.14.187.14.422zm-5.86-13.969q-1.265-1.594-2.437-2.437-1.148-.844-2.414-.844-1.148 0-1.992.586-.82.562-1.336 1.523-.492.961-.75 2.156-.234 1.172-.234 2.415 0 1.312.21 2.554.212 1.242.68 2.227.493.96 1.29 1.547.796.586 2.015.586.61 0 1.172-.164.586-.188 1.172-.586.61-.399 1.242-1.032.633-.656 1.383-1.593z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path890",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 48,
      fontFamily: "Calibri",
      InkscapeFontSpecification: "'Calibri, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "M294.702 120.34q0 .234-.14.422-.141.164-.47.281-.328.117-.914.164-.562.07-1.406.07-.867 0-1.453-.07-.563-.047-.89-.164-.329-.117-.47-.281-.14-.188-.14-.422V93.2q-.07.14-.211.21-.117.07-.305.07-.257 0-.68-.093-.421-.094-.937-.164-.515-.094-1.031-.118-.492-.046-.984-.046-1.055 0-1.758.21-.703.211-1.125.657-.399.422-.563 1.125-.164.703-.164 1.664v1.922h3.469q.234 0 .398.117.188.117.305.398.117.258.164.727.07.469.07 1.148 0 1.29-.234 1.852-.234.539-.68.539h-3.492v16.922q0 .234-.14.422-.141.164-.47.281-.327.117-.913.164-.563.07-1.43.07-.844 0-1.43-.07-.562-.047-.914-.164-.328-.117-.468-.281-.118-.188-.118-.422v-16.922h-2.625q-.445 0-.68-.54-.21-.562-.21-1.85 0-.68.047-1.15.07-.468.164-.726.117-.28.28-.398.188-.117.423-.117h2.601v-1.805q0-2.11.47-3.703.468-1.617 1.476-2.672 1.03-1.078 2.578-1.594 1.57-.539 3.773-.539.633 0 1.336.047.727.047 1.406.14.68.071 1.172.188.492.094.774.211.281.094.445.235.164.14.234.351.024-.21.118-.375.117-.164.398-.305.305-.14.867-.21.586-.094 1.547-.094.844 0 1.406.07.586.07.914.211.329.117.47.305.14.187.14.422z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path892",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 48,
      fontFamily: "Calibri",
      InkscapeFontSpecification: "'Calibri, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "M321.796 109.676q0 2.672-.704 4.875-.703 2.203-2.132 3.797-1.43 1.593-3.586 2.46-2.157.868-5.04.868-2.788 0-4.851-.774-2.062-.773-3.422-2.25-1.36-1.476-2.015-3.632-.657-2.157-.657-4.922 0-2.672.703-4.875.727-2.227 2.157-3.797 1.43-1.594 3.562-2.461 2.156-.867 5.04-.867 2.812 0 4.874.773 2.063.75 3.399 2.227 1.359 1.476 2.015 3.632.657 2.157.657 4.946zm-6.07.234q0-1.547-.259-2.836-.234-1.312-.82-2.273-.586-.961-1.57-1.5-.961-.54-2.438-.54-1.312 0-2.297.493-.984.469-1.617 1.406-.633.914-.96 2.227-.305 1.289-.305 2.953 0 1.547.257 2.86.258 1.288.82 2.25.587.96 1.571 1.5.984.515 2.438.515 1.335 0 2.32-.469.984-.492 1.617-1.406.633-.914.938-2.203.304-1.313.304-2.977z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path894",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 48,
      fontFamily: "Calibri",
      InkscapeFontSpecification: "'Calibri, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "M358.335 99.387q0 .258-.07.633-.071.375-.259 1.078l-5.578 18.914q-.117.398-.304.656-.188.234-.586.375-.375.14-1.102.187-.703.047-1.851.047-1.149 0-1.875-.07-.727-.047-1.149-.187-.398-.141-.586-.375-.187-.258-.281-.633l-3.516-12.703-.047-.211-.046.21-3.235 12.704q-.094.398-.281.656-.164.234-.586.375-.422.14-1.148.188-.727.046-1.875.046-1.172 0-1.899-.07-.703-.047-1.125-.187-.398-.141-.586-.375-.187-.258-.281-.633l-5.531-18.914q-.211-.68-.282-1.055-.046-.398-.046-.656 0-.235.117-.399.14-.187.468-.28.352-.118.915-.165.585-.047 1.453-.047.937 0 1.523.047.586.047.914.164.328.117.445.328.141.188.211.469l4.149 15.352.047.28.047-.28 3.89-15.352q.07-.281.211-.469.164-.21.469-.328.305-.117.844-.164.562-.047 1.43-.047.867 0 1.406.07.539.047.843.165.329.093.446.28.14.165.21.4l4.173 15.468.07.258.047-.281 3.984-15.352q.047-.281.188-.469.14-.21.468-.328.328-.117.891-.164.562-.047 1.43-.047.867 0 1.406.047.562.047.867.164.328.094.445.281.118.164.118.399z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeadermin);
export default __webpack_public_path__ + "static/media/logo_header.min.3d018034cd7ca0200bb5ceee98dd4660.svg";
export { ForwardRef as ReactComponent };